<style type="text/css" media="screen">

</style>
<template>
	<div>
		<v-data-table
		:headers="headers"
		:items="notification_list"
		:single-select="singleSelect"
		:hide-default-footer="true"
		:disable-sort="true"
		:items-per-page="$keys.PAGE_LENGTH"
		class="elevation-1 custome-header-bg custome-table-body"
		:loading="table_loading"
		>
		<!-- created_date  -->
		<template v-slot:item.created_date ="{ item }">
			<span >{{item.created_date}}, {{item.created_time}}</span>
		</template>	
		<!-- description -->
		<template v-slot:item.description="{ item }">
			<p class="fw-bold fs-14">{{item.title}}</p>
			<p class="secondary-text fs-12">{{item.body}}</p>
		</template>	

		<!--empty state  -->
		<template v-slot:no-data>
			<empty-list :message="$lang.EMPTY_SHIPMENTS"/>
		</template>	
	</v-data-table>

	<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
	@input="getNotoficatioList"></v-pagination>



</div>
</template>

<script type="text/javascript">
export default {
	data () {
		return {
			pdf_url:"",
			pdf:"",
			total_page_count:1,
			page_number:1,
			table_loading:false,
			notification_list:[],
			selected:[],
			shipment_id_list:[],
			singleSelect: false,
			shipment_serch_query:"",
			headers: [
			{ text: 'Date', value: 'created_date', width:"200px" },
			{ text: 'Notification Info', value: 'description' },
			],
			/*FILTER*/
			filter_data:{
				retailer_id_list:[],
				wholesaler_id_list:[],
				status_list:[],
				type_list:[],
				filter_date_from:"",
				filter_date_to:"",
				filter_count:0,
			},
			dialog:{
				shipment_id:"",
				flag:false,
			},


		}
	},
	created(){
		this.getNotoficatioList()
		this.$store.dispatch('drawer/setActiveTab',-1) 
	},
	methods:{
		/* fetching notification list */ 
		getNotoficatioList(){
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
			};
			self.table_loading=true

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					this.notification_list=response.data.notification_list
					this.total_page_count=response.data.total_page_count
				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.GET_NOTIFICATION_LIST,params,successHandler,null,null,finallyHandler)
		},
	}
}


</script>